import { Component } from '@angular/core';

@Component({
  selector: 'rmb-table-not-found',
  templateUrl: './table-not-found.component.html',
  styleUrls: ['./table-not-found.component.scss'],
  standalone: false,
})
export class TableNotFoundComponent {}
